(function() {
    'use strict';

    angular.module('businessUnitModule', []);

    /**
     *
     * @typedef {object} BusinessUnit
     * 
     * @property {number} BusinessUnitID
     * @property {number} Depth
     * @property {string} Description
     * @property {number} HeadID
     * @property {Person} Head
     * @property {boolean} IsDeleted
     * @property {Person[]} Members
     * @property {number} ParentBusinessUnitID
     * @property {BusinessUnit[]} ParentBusinessUnits
     * @property {number} ProcedureCodePrefixID
     * @property {string} ProcedureCodePrefix
     * @property {string} TitleEN
     */
})();